// @flow

import { makeApiCall } from '../../../../services/apiService/apiService';
import { minimumClientSearchCharacterLength } from '../../../../services/helpers';

export const clientSearchActions = {
  SET_CLIENT_LIST: 'SET_CLIENT_LIST',
  SET_IS_FETCHING_CLIENT_LIST: 'SET_IS_FETCHING_CLIENT_LIST',
  RESET_CLIENT_LIST_AND_FETCHING: 'RESET_CLIENT_LIST_AND_FETCHING',
  SET_CLIENT_SEARCH_INPUT: 'SET_CLIENT_SEARCH_INPUT'
};

const setIsFetchingClientList = payload => ({
  type: clientSearchActions.SET_IS_FETCHING_CLIENT_LIST,
  payload
});

const setClientList = payload => ({
  type: clientSearchActions.SET_CLIENT_LIST,
  payload
});

export const setClientSearchInput = payload => ({
  type: clientSearchActions.SET_CLIENT_SEARCH_INPUT,
  payload
});

const resetClientListAndIsFetching = () => ({
  type: clientSearchActions.RESET_CLIENT_LIST_AND_FETCHING
});

export const getClients = (
  cnoteType: String,
  searchString: String,
  isClientUser: boolean,
  shouldAddAllObject: boolean,
  clientListFilter: Function,
  onClientFetchSucess: Function,
  userProfile: Object,
  isEditPrq: boolean
) => (dispatch: Function) => {
  if (
    !isClientUser &&
    (!searchString || searchString.length < minimumClientSearchCharacterLength)
  ) {
    dispatch(resetClientListAndIsFetching());
    return [];
  }

  dispatch(setIsFetchingClientList(true));

  const replaceParamsArr = [
    { key: 'searchString', val: encodeURIComponent(searchString) || '' }
  ];
  if (cnoteType) {
    replaceParamsArr.push({ key: 'cnoteType', val: cnoteType });
  }

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: isClientUser ? 'getClientsByUser' : 'getClients',
    replaceParamsArr,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        if (shouldAddAllObject) {
          const allobj = {
            displayName: 'ALL',
            id: null
          };
          if (
            res.payload &&
            res.payload.length &&
            res.payload.findIndex(client => client.displayName === 'ALL') === -1
          ) {
            res.payload.unshift(allobj);
          }
        }
        dispatch(setIsFetchingClientList(false));

        const responseList = res.payload || [];
        const filteredList = clientListFilter
          ? clientListFilter(responseList, cnoteType, userProfile, isEditPrq)
          : responseList;
        dispatch(setClientList(filteredList));
        onClientFetchSucess(filteredList);
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line no-console
        console.log('getClients call 200 failure', res);
        dispatch(resetClientListAndIsFetching());
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('getClients call failed ', res);
      dispatch(resetClientListAndIsFetching());
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in getClients call', res);
      dispatch(resetClientListAndIsFetching());
    }
  };

  return makeApiCall(requestObj);
};
